import { InjectionToken } from '@angular/core';

/**
 * Backend base URL supplied by the SSR server.
 *
 * In development this matches Environment.localApiURL, but in production
 * blue-green deployments the backend container name differs from the hard-coded
 * 'backend' hostname, so the server must inject the correct internal URL.
 */
export const SSR_BACKEND_BASE_URL = new InjectionToken<string>('SSR_BACKEND_BASE_URL');
